import React, { useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function SubmitDownloadLogPublic() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { devOrderId } = useParams();
  const { t } = useTranslation('common');

  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const logId = queryParams.get('logId');
  const reqId = queryParams.get('reqId');
  const validateEmail = (email) => {
    const pattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
    return pattern.test(email);
  };
  const encodedEmail = encodeURIComponent(email);

  console.log('encodedEmailencodedEmail', encodedEmail);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      setSubmitted(true);
      setHasError(false);
      if (devOrderId) {
        history.push(`/development-order/${devOrderId}/submit-download-logs?logId=${logId}&forMail=true&email=${encodedEmail}`);
      } else {
        history.push(`/multi-submit-download-logs?reqId=${reqId}&email=${email}&integrated=false`);
      }
    } else {
      console.log('invalid email');
      setHasError(true);
    }
  };

  return (
    <div className="submit-download-box">
      <Row>
        <Col md="12" lg="12" sm="12">
          <h4 className="mb-4">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_PUBLIC_LOG.CONTENT_EMAIL_ADDRESS')}</h4>
          <div className="input-group form-floating-label fixed-label left-addon">
            <input
              type="email"
              className={`form-control ${hasError ? 'is-invalid' : ''}`}
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label className="asterisk-req" htmlFor="email">
              {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_PUBLIC_LOG.EMAIL')} <span>*</span>
            </label>
            {hasError && <div className="invalid-feedback">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_PUBLIC_LOG.PLEASE_VALID_EMAIL')}</div>}
          </div>
        </Col>
        <Col md="12" lg="12" sm="12">
          <div className="pt-3 text-right">
            <button className="btn btn-outline btn-back-lib d-inline-flex m-0" type="button" disabled={submitted} onClick={(e) => handleSubmit(e)}>
              {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_PUBLIC_LOG.SUBMIT')}
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default SubmitDownloadLogPublic;
